import { Box, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import VinButton from '../Header/VinButton'
import FindVin from '../Header/FindVin'
import { fontText, fontTextHead, fontTitle, fullCenter } from '../../../base'
import { Txt } from '../../../Routes/Localized'
import { theme } from '../../../Resources/Design/theme'

export default function CheckNow({ sx = {} }) {
    const vertical = useMediaQuery("(max-width:1000px)");

    return (
        <Box sx={{ bgcolor: '#0165F4', borderRadius: '20px', ...sx }}>
            <Box sx={{
                px: { xs: '16px', sm: '16px', md: '32px' }, display: 'flex', flexDirection: vertical ? 'column' : 'row',
                py: { xs: '60px', sm: '60px', md: '80px' }
            }}>
                <Box sx={{
                    maxWidth: '750px', display: 'flex', flexDirection: 'column', textAlign: 'left', flex: 1,
                    ml: { xs: '0px', sm: '0px', md: '12px' }
                }}>
                    <Typography sx={{ fontFamily: 'inter', fontWeight: 700, ...fontTitle, color: 'white' }}>
                        <Txt id={"21010"} />
                    </Typography>
                    <Typography sx={{
                        fontFamily: 'inter', fontWeight: 400, ...fontTextHead, [theme.breakpoints.down('md')]: {
                            fontWeight: 400
                        }, color: 'white', mt: '20px'
                    }}>
                        <Txt id={"21016"} />
                    </Typography>
                </Box>

                <Box sx={{ maxWidth: '536px', flex: 1, ml: vertical ? '0px' : '64px', mt: vertical ? '20px' : '0px' }}>
                    <VinButton buttonTextInit={<Txt id={"11027"} />} />
                    <FindVin />
                </Box>
            </Box>
        </Box>
    )
}
